var React = require('react');

function LogoMark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m33.5458 0 33.5456 19.3677v38.7353l-7.5397 4.353v-38.7353l-26.0059-15.01462-26.00609 15.01462v30.0292l33.54579 19.3674-7.5397 4.3533-33.5458-19.3676v-38.7353zm15.0794 51.539v17.2389l-7.5397 4.353v-17.2389zm9.2326-16.0839v27.9807l-7.5396 4.353v-27.9807z","fill":"currentColor"}));
}

LogoMark.defaultProps = {"height":"78","viewBox":"0 0 68 78","width":"68"};

module.exports = LogoMark;

LogoMark.default = LogoMark;
